import { InlineAlert } from 'edrolo-style-guide';
import { ERROR_MESSAGES } from 'edrolo/constants/ErrorMessages';
import PT from 'prop-types';

export const ErrorAlert = ({ statusCode }) => {
  const code = ERROR_MESSAGES[statusCode] ? statusCode : 'unknown';

  return (
    <InlineAlert type="error">
      <strong>{ERROR_MESSAGES[code].title}</strong>
      &nbsp;&mdash;&nbsp;
      {ERROR_MESSAGES[code].message}
    </InlineAlert>
  );
};

ErrorAlert.propTypes = {
  statusCode: PT.number,
};
